import { UserViewModel } from 'stageclip-common';

export function userFullName(user: UserViewModel) {
  return `${user.firstName} ${user.lastName}`;
}
